export default __webpack_public_path__ + "c2f9a4d8755a81d7ba59b379669debdc.png";